/**
 * Reset Parts Finder (Seeker) Year/Make/Model and search to defaults on every page load.
 * Clears any persisted state and resets dropdowns to "Select Year", "Select Make", "Select Model".
 */
(function() {
  var KEY_PREFIXES = ['seeker', 'wnpf', 'ymm', 'parts', 'year', 'make', 'model', 'leadermoto', 'nexusbyte', 'dropdown'];

  function clearPersistedState() {
    try {
      [localStorage, sessionStorage].forEach(function(storage) {
        var keysToRemove = [];
        for (var i = 0; i < storage.length; i++) {
          var key = storage.key(i);
          if (key && KEY_PREFIXES.some(function(prefix) { return key.toLowerCase().indexOf(prefix) !== -1; })) {
            keysToRemove.push(key);
          }
        }
        keysToRemove.forEach(function(k) { storage.removeItem(k); });
      });
    } catch (e) {}
  }

  function resetSelect(select) {
    if (!select || select.tagName !== 'SELECT') return;
    var firstOption = select.options[0];
    if (firstOption) {
      select.selectedIndex = 0;
      select.value = firstOption.value || '';
    } else {
      select.value = '';
    }
  }

  function resetInput(input) {
    if (input && (input.type === 'text' || input.type === 'search')) input.value = '';
  }

  var DROPDOWN_LEFT_PADDING = '1.25rem';
  var DROPDOWN_RIGHT_PADDING = '2rem';
  var PADDING_STYLE_ID = 'seeker-dropdown-padding-injected';
  var INLINE_LAYOUT_STYLE_ID = 'seeker-inline-layout-injected';

  function wantsInlineLayout(root) {
    if (root.getAttribute('data-layout') === 'inline') return true;
    var wrap = root.closest && root.closest('[data-seeker-layout="inline"]');
    if (wrap) return true;
    return !!root.closest && root.closest('.seeker-one-row');
  }

  function forceOneRowBruteForce(root) {
    if (!wantsInlineLayout(root) || window.innerWidth < 768) return;
    var sr = root.shadowRoot;
    if (!sr) return;

    var selectionDropdowns = sr.querySelector('.selection-dropdowns');
    var searchOptions = sr.querySelector('.search-options');
    var rowWrapper = null;

    if (selectionDropdowns && searchOptions && selectionDropdowns.parentElement === searchOptions.parentElement) {
      rowWrapper = selectionDropdowns.parentElement;
    }
    if (!rowWrapper && selectionDropdowns && selectionDropdowns.parentElement) {
      rowWrapper = selectionDropdowns.parentElement;
    }
    if (!rowWrapper) {
      var first = sr.firstElementChild;
      if (first) {
        for (var depth = 0; depth < 5 && first; depth++) {
          if (first.children.length >= 2) {
            var hasSelect = first.querySelector && first.querySelector('select');
            var hasButton = first.querySelector && first.querySelector('button');
            if (hasSelect && (hasButton || first.children.length >= 3)) {
              rowWrapper = first;
              break;
            }
          }
          first = first.children.length === 1 ? first.firstElementChild : null;
        }
      }
      if (!rowWrapper && sr.firstElementChild) rowWrapper = sr.firstElementChild;
    }

    if (rowWrapper) {
      rowWrapper.style.setProperty('display', 'flex', 'important');
      rowWrapper.style.setProperty('flex-direction', 'row', 'important');
      rowWrapper.style.setProperty('flex-wrap', 'nowrap', 'important');
      rowWrapper.style.setProperty('align-items', 'stretch', 'important');
      rowWrapper.style.setProperty('width', '100%', 'important');
      rowWrapper.style.setProperty('max-width', '100%', 'important');
      rowWrapper.style.setProperty('gap', '0 0.75rem', 'important');

      var idx = 0;
      var total = rowWrapper.children.length;
      for (var i = 0; i < rowWrapper.children.length; i++) {
        var kid = rowWrapper.children[i];
        var isLast = i === rowWrapper.children.length - 1;
        kid.style.setProperty('display', 'flex', 'important');
        kid.style.setProperty('flex-direction', 'row', 'important');
        kid.style.setProperty('flex-wrap', 'nowrap', 'important');
        kid.style.setProperty('margin', '0', 'important');
        kid.style.setProperty('flex', isLast ? '1 1 auto' : '0 0 auto', 'important');
        kid.style.setProperty('min-width', isLast ? '12rem' : '7rem', 'important');
        kid.style.setProperty('width', 'auto', 'important');
        kid.style.setProperty('max-width', isLast ? 'none' : 'none', 'important');

        if (kid.classList && kid.classList.contains('selection-dropdowns')) {
          kid.style.setProperty('flex', '0 0 auto', 'important');
          for (var j = 0; j < kid.children.length; j++) {
            kid.children[j].style.setProperty('display', 'flex', 'important');
            kid.children[j].style.setProperty('flex-direction', 'row', 'important');
            kid.children[j].style.setProperty('flex', '0 0 auto', 'important');
            kid.children[j].style.setProperty('width', 'auto', 'important');
            kid.children[j].style.setProperty('min-width', '7rem', 'important');
            kid.children[j].style.setProperty('margin-bottom', '0', 'important');
          }
        }
        if (kid.classList && kid.classList.contains('search-options')) {
          kid.style.setProperty('flex', '1 1 auto', 'important');
          var inp = kid.querySelector('input');
          var btn = kid.querySelector('button');
          if (inp) {
            inp.style.setProperty('flex', '1 1 auto', 'important');
            inp.style.setProperty('min-width', '8rem', 'important');
            inp.style.setProperty('margin-bottom', '0', 'important');
          }
          if (btn) {
            btn.style.setProperty('flex', '0 0 auto', 'important');
            btn.style.setProperty('width', 'auto', 'important');
            btn.style.setProperty('margin-top', '0', 'important');
          }
        }
      }
    }

    var top = sr.firstElementChild;
    if (top && top !== rowWrapper) {
      top.style.setProperty('display', 'flex', 'important');
      top.style.setProperty('flex-direction', 'row', 'important');
      top.style.setProperty('flex-wrap', 'nowrap', 'important');
      top.style.setProperty('width', '100%', 'important');
      top.style.setProperty('max-width', '100%', 'important');
      if (top.children.length === 1) {
        top.firstElementChild.style.setProperty('display', 'flex', 'important');
        top.firstElementChild.style.setProperty('flex-direction', 'row', 'important');
        top.firstElementChild.style.setProperty('flex-wrap', 'nowrap', 'important');
        top.firstElementChild.style.setProperty('width', '100%', 'important');
      }
    }
  }

  function injectInlineLayoutStyle(root) {
    if (!wantsInlineLayout(root) || window.innerWidth < 768) return;
    var sr = root.shadowRoot;
    if (!sr) return;
    var existing = sr.getElementById(INLINE_LAYOUT_STYLE_ID);
    if (existing) existing.remove();
    var style = document.createElement('style');
    style.id = INLINE_LAYOUT_STYLE_ID;
    style.textContent = '@media (min-width:768px){:host{width:100%!important;max-width:100%!important}:host>*,:host nav,:host form,:host>div,:host>div>*{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:stretch!important;width:100%!important;max-width:100%!important;gap:0 .75rem!important}:host .selection-dropdowns{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;max-width:none!important;width:auto!important;margin:0!important;flex:0 0 auto!important}:host .selection-dropdowns>*{width:auto!important;max-width:none!important;min-width:7rem!important;flex:0 0 auto!important;margin-bottom:0!important}:host .search-options{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;max-width:none!important;width:auto!important;flex:1 1 auto!important;margin:0!important;min-width:12rem!important}:host .search-options input{flex:1 1 auto!important;min-width:8rem!important;margin-bottom:0!important}:host .search-options button{width:auto!important;max-width:none!important;margin-top:0!important;flex:0 0 auto!important}}';
    sr.appendChild(style);
  }

  function applyInlineLayout(root) {
    if (!wantsInlineLayout(root)) return;
    if (root.getAttribute('data-layout') !== 'inline') root.setAttribute('data-layout', 'inline');
    injectInlineLayoutStyle(root);
    var container = root.shadowRoot || root;
    if (!container || !container.querySelector) return;

    var selectionDropdowns = container.querySelector('.selection-dropdowns');
    var searchOptions = container.querySelector('.search-options');
    var wrapper = null;
    if (selectionDropdowns && searchOptions && selectionDropdowns.parentElement) wrapper = selectionDropdowns.parentElement;
    if (!wrapper && window.innerWidth >= 768) {
      var allSelects = container.querySelectorAll('select');
      var allButtons = container.querySelectorAll('button');
      if (allSelects.length >= 1 && allButtons.length >= 1) {
        wrapper = allSelects[0].parentElement;
        while (wrapper && wrapper !== container) {
          if (wrapper.querySelectorAll('select').length >= 1 && wrapper.querySelector('button')) break;
          wrapper = wrapper.parentElement;
        }
      }
    }
    if (!wrapper) return;

    var isDesktop = window.innerWidth >= 768;
    function setStyle(el, props) {
      if (!el) return;
      for (var k in props) {
        var cssKey = k.replace(/([A-Z])/g, function(m) { return '-' + m.toLowerCase(); });
        if (props[k] === '') el.style.removeProperty(cssKey);
        else el.style.setProperty(cssKey, props[k], 'important');
      }
    }

    if (isDesktop) {
      setStyle(wrapper, { display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'stretch', width: '100%', maxWidth: '100%', gap: '0 0.75rem' });
      if (selectionDropdowns) {
        setStyle(selectionDropdowns, { display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', maxWidth: 'none', width: 'auto', margin: '0', flex: '0 0 auto' });
        for (var d = 0; d < selectionDropdowns.children.length; d++) {
          setStyle(selectionDropdowns.children[d], { width: 'auto', maxWidth: 'none', minWidth: '7rem', flex: '0 0 auto', marginBottom: '0' });
        }
      }
      if (searchOptions) {
        setStyle(searchOptions, { display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', maxWidth: 'none', width: 'auto', flex: '1 1 auto', margin: '0', minWidth: '12rem' });
        var searchInput = searchOptions.querySelector('input');
        var searchBtn = searchOptions.querySelector('button');
        if (searchInput) setStyle(searchInput, { flex: '1 1 auto', minWidth: '8rem', marginBottom: '0' });
        if (searchBtn) setStyle(searchBtn, { width: 'auto', maxWidth: 'none', marginTop: '0', flex: '0 0 auto' });
      } else {
        var kids = wrapper.children;
        for (var k = 0; k < kids.length; k++) {
          setStyle(kids[k], { display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', width: 'auto', margin: '0', flex: k === kids.length - 1 ? '1 1 auto' : '0 0 auto' });
        }
      }
    } else {
      setStyle(wrapper, { display: '', flexDirection: '', flexWrap: '', alignItems: '', width: '', maxWidth: '', gap: '' });
      if (selectionDropdowns) {
        setStyle(selectionDropdowns, { display: '', flexDirection: '', flexWrap: '', maxWidth: '', width: '', margin: '', flex: '' });
        for (var d2 = 0; d2 < selectionDropdowns.children.length; d2++) setStyle(selectionDropdowns.children[d2], { width: '', maxWidth: '', minWidth: '', flex: '', marginBottom: '' });
      }
      if (searchOptions) setStyle(searchOptions, { display: '', flexDirection: '', flexWrap: '', maxWidth: '', width: '', flex: '', margin: '', minWidth: '' });
    }
  }

  function applyInlineLayoutStyle(root) {
    if (!wantsInlineLayout(root)) return;
    injectInlineLayoutStyle(root);
    forceOneRowBruteForce(root);
    applyInlineLayout(root);
  }

  function applyDropdownPadding(root) {
    var container = root.shadowRoot || root;
    if (!container || !container.querySelectorAll) return;

    if (root.shadowRoot) {
      if (!root.shadowRoot.getElementById(PADDING_STYLE_ID)) {
        var style = document.createElement('style');
        style.id = PADDING_STYLE_ID;
        style.textContent = [
          'select { padding-left: ' + DROPDOWN_LEFT_PADDING + ' !important; padding-right: ' + DROPDOWN_RIGHT_PADDING + ' !important; box-sizing: border-box !important; }',
          '.select, div.select { padding-left: ' + DROPDOWN_LEFT_PADDING + ' !important; padding-right: ' + DROPDOWN_RIGHT_PADDING + ' !important; box-sizing: border-box !important; }',
          '.selection-dropdowns .select, .selection-dropdowns div.select { padding-left: ' + DROPDOWN_LEFT_PADDING + ' !important; padding-right: ' + DROPDOWN_RIGHT_PADDING + ' !important; }'
        ].join(' ');
        root.shadowRoot.appendChild(style);
      }
    } else {
      var docStyle = document.getElementById(PADDING_STYLE_ID);
      if (!docStyle) {
        docStyle = document.createElement('style');
        docStyle.id = PADDING_STYLE_ID;
        docStyle.textContent = [
          'seeker-dropdown-parts-finder-root select { padding-left: ' + DROPDOWN_LEFT_PADDING + ' !important; padding-right: ' + DROPDOWN_RIGHT_PADDING + ' !important; box-sizing: border-box !important; }',
          'seeker-dropdown-parts-finder-root .select, seeker-dropdown-parts-finder-root div.select { padding-left: ' + DROPDOWN_LEFT_PADDING + ' !important; padding-right: ' + DROPDOWN_RIGHT_PADDING + ' !important; box-sizing: border-box !important; }'
        ].join(' ');
        document.head.appendChild(docStyle);
      }
    }

    var selects = container.querySelectorAll('select');
    for (var s = 0; s < selects.length; s++) {
      var sel = selects[s];
      if (sel && sel.tagName === 'SELECT') {
        sel.style.setProperty('padding-left', DROPDOWN_LEFT_PADDING, 'important');
        sel.style.setProperty('padding-right', DROPDOWN_RIGHT_PADDING, 'important');
        sel.style.setProperty('box-sizing', 'border-box', 'important');
      }
    }
    var wrappers = container.querySelectorAll('.select, div.select, [class*="select"]');
    for (var w = 0; w < wrappers.length; w++) {
      var el = wrappers[w];
      if (el && (el.classList.contains('select') || (el.tagName === 'DIV' && el.className && String(el.className).indexOf('select') !== -1))) {
        el.style.setProperty('padding-left', DROPDOWN_LEFT_PADDING, 'important');
        el.style.setProperty('padding-right', DROPDOWN_RIGHT_PADDING, 'important');
        el.style.setProperty('box-sizing', 'border-box', 'important');
      }
    }
  }

  function resetRoot(root) {
    var container = root.shadowRoot || root;
    if (!container) return;
    var selects = container.querySelectorAll ? container.querySelectorAll('select') : [];
    var inputs = container.querySelectorAll ? container.querySelectorAll('input[type="text"], input[type="search"]') : [];
    for (var s = 0; s < selects.length; s++) resetSelect(selects[s]);
    for (var i = 0; i < inputs.length; i++) resetInput(inputs[i]);
    applyDropdownPadding(root);
    applyInlineLayoutStyle(root);
  }

  function runReset() {
    clearPersistedState();
    var roots = document.querySelectorAll('seeker-dropdown-parts-finder-root');
    for (var r = 0; r < roots.length; r++) {
      resetRoot(roots[r]);
      applyDropdownPadding(roots[r]);
    }
  }

  function scheduleReset() {
    runReset();
    setTimeout(runReset, 100);
    setTimeout(runReset, 500);
    setTimeout(runReset, 1200);
    setTimeout(runReset, 2500);
    setTimeout(runReset, 4000);
    setTimeout(runReset, 6000);
    var pollCount = 0;
    var pollId = setInterval(function() {
      pollCount++;
      runPaddingOnAllWidgets();
      if (pollCount >= 100) clearInterval(pollId);
    }, 300);
  }

  function observeWidget(root) {
    if (root._seekerPaddingObserved) return;
    root._seekerPaddingObserved = true;

    function attachToTarget(target) {
      if (!target || !target.querySelectorAll) return;
      applyDropdownPadding(root);
      applyInlineLayoutStyle(root);
      var obs = new MutationObserver(function() {
        applyDropdownPadding(root);
        applyInlineLayoutStyle(root);
      });
      try {
        obs.observe(target, { childList: true, subtree: true });
      } catch (e) {}
    }

    if (root.shadowRoot) {
      attachToTarget(root.shadowRoot);
      applyInlineLayoutStyle(root);
      var reapplies = 0;
      var reapplyId = setInterval(function() {
        reapplies++;
        applyInlineLayoutStyle(root);
        if (reapplies >= 10) clearInterval(reapplyId);
      }, 400);
      return;
    }
    applyDropdownPadding(root);
    var attempts = 0;
    var maxAttempts = 150;
    var poll = setInterval(function() {
      attempts++;
      if (root.shadowRoot) {
        clearInterval(poll);
        attachToTarget(root.shadowRoot);
        applyInlineLayoutStyle(root);
        runReset();
        var reapplies = 0;
        var reapplyId = setInterval(function() {
          reapplies++;
          applyInlineLayoutStyle(root);
          if (reapplies >= 10) clearInterval(reapplyId);
        }, 400);
        return;
      }
      if (attempts >= maxAttempts) clearInterval(poll);
    }, 200);
  }

  function runPaddingOnAllWidgets() {
    var roots = document.querySelectorAll('seeker-dropdown-parts-finder-root');
    for (var r = 0; r < roots.length; r++) {
      applyDropdownPadding(roots[r]);
      applyInlineLayoutStyle(roots[r]);
      observeWidget(roots[r]);
    }
  }

  var resizeTimeout;
  function onResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      runPaddingOnAllWidgets();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scheduleReset();
      runPaddingOnAllWidgets();
      setTimeout(runPaddingOnAllWidgets, 300);
      setTimeout(runPaddingOnAllWidgets, 1000);
      setTimeout(runPaddingOnAllWidgets, 2000);
      setTimeout(runPaddingOnAllWidgets, 5000);
      setTimeout(runPaddingOnAllWidgets, 10000);
    });
  } else {
    scheduleReset();
    runPaddingOnAllWidgets();
    setTimeout(runPaddingOnAllWidgets, 300);
    setTimeout(runPaddingOnAllWidgets, 1000);
    setTimeout(runPaddingOnAllWidgets, 2000);
    setTimeout(runPaddingOnAllWidgets, 5000);
    setTimeout(runPaddingOnAllWidgets, 10000);
  }
  window.addEventListener('pageshow', function(ev) {
    if (ev.persisted) {
      scheduleReset();
      runPaddingOnAllWidgets();
    }
  });
  window.addEventListener('resize', onResize);
  window.addEventListener('load', function() {
    runPaddingOnAllWidgets();
    setTimeout(runPaddingOnAllWidgets, 500);
    setTimeout(runPaddingOnAllWidgets, 2000);
    setTimeout(runPaddingOnAllWidgets, 5000);
  });
  if (typeof customElements !== 'undefined' && customElements.whenDefined) {
    customElements.whenDefined('seeker-dropdown-parts-finder-root').then(function() {
      scheduleReset();
      runPaddingOnAllWidgets();
      setTimeout(runPaddingOnAllWidgets, 500);
    });
  }
})();
